import { render, staticRenderFns } from "./addProcess.vue?vue&type=template&id=56132225&scoped=true&"
import script from "./addProcess.vue?vue&type=script&lang=js&"
export * from "./addProcess.vue?vue&type=script&lang=js&"
import style0 from "./addProcess.vue?vue&type=style&index=0&id=56132225&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56132225",
  null
  
)

export default component.exports